import { DsrActivity } from '@xpo-ltl/sdk-linehaulpayform';

export class AddEditActivityData {
  constructor(public title: string, public activity: DsrActivity, public schSequenceNbr: string) {}
}
